import React from 'react';
import styled from 'styled-components';
import { uiColors } from '../../common/styles';

const Wrapper = styled.section`
    position: relative;
    overflow: hidden;
    background: #e5e7eb;
    border-radius: 25px;
    width: 100%;
    height: 12px;
    margin-bottom: 10px;
    margin-top: 10px;
`;

const TransformBar = styled.section`
    position: absolute;
    left: -100%;
    border-radius: 25px;
    background-color: ${uiColors.PRIMARY};
    height: 100%;
    width: 100%;
    transform-origin: left;
    transition: 0.5s;
    margin-bottom: 10px;
`;

const FramiProgress = ({ percent }) => {
    return (
        <Wrapper>
            <TransformBar style={{ left: `${-100 + percent}%` }} />
        </Wrapper>
    );
};

export default FramiProgress;
